import P from '../../comps/P';

export default P;
